import React from 'react';

import './landing.css';

import Underline from './underline/underline'

import iphone from '../../assets/iphone.png';

import bulb from '../../assets/bulbAsset.png';

function Landing() {
    return (
      <div className="landing--container">
        <img src={iphone} className="landing--phone" alt="landing--phone"/>
        <img src={bulb} className="landing--bulb" alt="landing--bulb"/>
        
        <div className="landing--header--cont">
        
          <Underline
            delay="0"
          >
            <h1 className="landing--header">Welcome To Bulby Tech</h1>
          </Underline>

          <p className="sub--header">
            Looking to grow your small buisness? <br/>
            We specialize in 
            Web development, Ecommerce, Mobile development, automation, and more          
          </p>
        </div>

        <Underline>
          <h3>Scroll to Learn More</h3>
        </Underline>
      </div>
    );
  }
  
  export default Landing;
  